import Emplacement from '@/views/gabed/emplacement/l_emplacementDispositifsMaterielsFaces';
import AjoutEmplacement from '@/views/gabed/emplacement/m_ajoutEmplacement';
import adresseEmplacement from '@/views/gabed/emplacement/adresse/m_adresse';
import parkingEmplacement from '@/views/gabed/emplacement/parking/m_parking';
import centreCommercialEmplacement from '@/views/gabed/emplacement/centreCommercial/m_centreCommercial';
import ligneBusEmplacement from '@/views/gabed/emplacement/ligneBus/m_ligneBus';
import clientEmplacement from '@/views/gabed/emplacement/client/m_clientEmplacement';
import consultationCentreCommercial from '@/views/gabed/emplacement/centreCommercial/c_centreCommercial';
import consultationLigneBus from '@/views/gabed/emplacement/ligneBus/c_ligneBus';
import consultationAdresse from '@/views/gabed/emplacement/adresse/c_adresse';
import consultationParking from '@/views/gabed/emplacement/parking/c_parking';
import consultationClient from '@/views/gabed/emplacement/client/c_clientEmplacement';
import DetailEmplacement from '@/views/gabed/emplacement/c_detailEmplacement';
import ManagerStepDispositifMaterielFace from '@/views/gabed/dispositif/m_managerStepDispositifMaterielFace';
import detailDispositifPublicitaire from '@/views/gabed/dispositif/c_dispositifPublicitaire';
import detailMateriel from '@/views/gabed/materiel/c_materiel';
import detailFace from '@/views/gabed/face/c_face';
import editionDispositifPublicitaire
  from '@/views/gabed/dispositif/m_editionDispositifPublicitaire';
import editionMateriel from '@/views/gabed/materiel/m_editionMateriel';
import listeCollectivite from '@/views/gabed/collectivite/l_collectivite';
import editionCollectivite from '@/views/gabed/collectivite/m_collectivite';
import collectivite from '@/views/gabed/collectivite/c_collectivite';
import editionFournisseur from '@/views/commun/fournisseur/m_fournisseur';
import listeConfrere from '@/views/commun/confrere/l_confrere';
import listeFournisseurMateriel from '@/views/commun/fournisseurMateriel/l_fournisseurMateriel';
import detailFournisseur from '@/views/commun/fournisseur/c_fournisseur';
import RemplacementProduitFace from '@/views/gabed/face/remplacement/m_remplacementProduitFace';
import materielTlpe from '@/views/gabed/tlpe/l_materiel';
import declarationTlpe from '@/views/gabed/tlpe/l_declaration';
import declarationTlpeAuFilDeLeau from '@/views/gabed/tlpe/l_declarationAuFilDeLeau';
import listeCommandeTlpe from '@/views/gabed/commandeTlpe/l_commandeTlpe';
import editionCommandeTlpe from '@/views/gabed/commandeTlpe/m_commandeTlpe';
import detailCommandeTlpe from '@/views/gabed/commandeTlpe/c_commandeTlpe';
import editionTitreRecette from '@/views/gabed/titreRecette/m_titreRecette';
import listeTitreRecette from '@/views/gabed/titreRecette/l_titreRecette';
import listePaiementRecette from '@/views/gabed/titreRecette/paiement/l_paiementRecette';
import detailTitreRecette from '@/views/gabed/titreRecette/c_titreRecette';
import listeLotPaiementRecette from '@/views/gabed/titreRecette/lotDePaiement/l_lotPaiementRecette';
import detailLotPaiementRecette from '@/views/baux/lotPaiement/c_lotPaiement';
import editionLotPaiementRecette from '@/views/baux/lotPaiement/m_lotPaiement';
import listeJournalPaiementRecette from '@/views/gabed/titreRecette/journalPaiment/l_journalPaiementRecette';
import { PAGE_DEFAULT } from './routerConf';

export default [
  {
    path: '/ajoutEmplacement',
    component: AjoutEmplacement,
    name: 'm.gabed.emplacement-ajoutEmplacement',
  },
  {
    path: '/emplacement/:activeTab?/:tiersId?',
    component: Emplacement,
    name: 'l.gabed.emplacement',
  },
  {
    path: '/detailEmplacement/:id',
    component: DetailEmplacement,
    name: 'c.gabed.emplacement-detailEmplacement',
  },
  // Emplacement Client
  {
    path: 'ajout-emplacementClient',
    component: clientEmplacement,
    name: 'm.gabed.emplacement-client',
  },
  {
    path: 'edition-emplacementClient/:id',
    component: clientEmplacement,
    name: 'm.gabed.emplacement-clientModification',
  },
  {
    path: '/emplacementClient/:id',
    component: consultationClient,
    name: 'c.gabed.emplacement-client',
  },
  // Emplacement Adresse
  {
    path: 'ajout-emplacementAdresse',
    component: adresseEmplacement,
    name: 'm.gabed.emplacement-adresse',
  },
  {
    path: 'emplacementAdresse/:id',
    component: consultationAdresse,
    name: 'c.gabed.emplacement-adresse',
  },
  {
    path: 'edition-emplacementAdresse/:id',
    component: adresseEmplacement,
    name: 'm.gabed.emplacement-adresseModification',
  },
  // Emplacement Centre Commercial
  {
    path: 'ajout-emplacementCentreCommercial',
    component: centreCommercialEmplacement,
    name: 'm.gabed.emplacement-centreCommercial',
  },
  {
    path: 'emplacementCentreCommercial/:id',
    component: consultationCentreCommercial,
    name: 'c.gabed.emplacement-centreCommercial',
  },
  {
    path: 'edition-emplacementCentreCommercial/:id',
    component: centreCommercialEmplacement,
    name: 'm.gabed.emplacement-centreCommercialModification',
  },
  // Emplacement Ligne Bus
  {
    path: 'ajout-emplacementLigneBus',
    component: ligneBusEmplacement,
    name: 'm.gabed.emplacement-ligneBus',
  },
  {
    path: 'emplacementLigneBus/:id',
    component: consultationLigneBus,
    name: 'c.gabed.emplacement-ligneBus',
  },
  {
    path: 'edition-emplacementLigneBus/:id',
    component: ligneBusEmplacement,
    name: 'm.gabed.emplacement-ligneBusModification',
  },
  // Emplacement Parking
  {
    path: 'ajout-emplacementParking',
    component: parkingEmplacement,
    name: 'm.gabed.emplacement-parking',
  },
  {
    path: 'emplacementParking/:id',
    component: consultationParking,
    name: 'c.gabed.emplacement-parking',
  },
  {
    path: 'edition-emplacementParking/:id',
    component: parkingEmplacement,
    name: 'm.gabed.emplacement-parkingModification',
  },
  { // ajout dispositif + materiel + face
    path: 'ajoutDispositifPublicitaire/:id',
    component: ManagerStepDispositifMaterielFace,
    name: 'm.gabed.emplacement-dispositifPublicitaire',
  },
  { // ajouter depuis dispositif existant
    path: 'ajoutMateriel/:idDispositifExistant',
    component: ManagerStepDispositifMaterielFace,
    name: 'm.gabed.emplacement-ajoutMateriel',
  },
  // Dispositif
  {
    path: 'detailDispositifPublicitaire/:idDispositif',
    component: detailDispositifPublicitaire,
    name: 'c.gabed.emplacement-detailDispositif',
  },
  {
    path: 'edition-dispositifPublicitaire/:idDispositif',
    component: editionDispositifPublicitaire,
    name: 'm.gabed.emplacement-dispositifPublicitaireEdition',
  },
  // Matériel
  {
    path: 'detailMateriel/:idMateriel/:activeTab?',
    component: detailMateriel,
    name: 'c.gabed.emplacement-detailMateriel',
  },
  {
    path: 'editMateriel/:idMateriel',
    component: editionMateriel,
    name: 'm.gabed.emplacement-materielEdition',
  },
  // Face
  {
    path: 'detailFace/:idFace',
    component: detailFace,
    name: 'c.gabed.emplacement-face',
  },
  {
    path: 'editFace/:idMateriel/face/:idFace',
    component: editionMateriel,
    name: 'm.gabed.emplacement-faceEdition',
  },
  {
    path: 'listeCollectivite',
    component: listeCollectivite,
    name: 'l.gabed.collectivite',
  },
  {
    path: 'ajoutCollectivite',
    component: editionCollectivite,
    name: 'm.gabed.collectivite',
  },
  {
    path: 'editionCollectivite/:id',
    component: editionCollectivite,
    name: 'm.gabed.collectivite-edition',
  },
  {
    path: 'detailCollectivite/:id?',
    component: collectivite,
    name: 'c.gabed.collectivite',
  },
  {
    path: '/ajoutFournisseur/:sousTypeFrom',
    component: editionFournisseur,
    name: 'm.gabed.confrere',
  },
  {
    path: '/detailConfrere/:id/:sousTypeFrom',
    component: detailFournisseur,
    name: 'c.gabed.confrere',
  },
  {
    path: '/editionFournisseur/:id/:sousTypeFrom',
    component: editionFournisseur,
    name: 'm.gabed.confrere-edition',
  },
  {
    path: '/listeConfrere',
    component: listeConfrere,
    name: 'l.gabed.confrere',
  },
  {
    path: '/remplacementProduitFace',
    component: RemplacementProduitFace,
    name: 'm.gabed.emplacement-remplacementProduitFace',
  },
  {
    path: '/materielTlpe/:id?',
    component: materielTlpe,
    name: 'l.gabed.materielTlpe',
  },
  {
    path: '/declarationTlpe',
    component: declarationTlpe,
    name: 'l.gabed.declarationTlpe',
  },
  {
    path: '/declarationTlpeAuFilDeLeau',
    component: declarationTlpeAuFilDeLeau,
    name: 'l.gabed.declarationTlpe-AuFilDeLeau',
  },
  {
    path: '/listeCommandeTlpe/:tiersId?/:annee?/:isFilDeLeau?',
    component: listeCommandeTlpe,
    name: 'l.gabed.commande_tlpe',
  },
  {
    path: '/editCommandeTlpe/:id',
    component: editionCommandeTlpe,
    name: 'm.gabed.commande_tlpe-edition',
  },
  {
    path: '/detailCommandeTlpe/:id',
    component: detailCommandeTlpe,
    name: 'c.gabed.commande_tlpe',
  },
  {
    path: '/listeFournisseurMateriel',
    component: listeFournisseurMateriel,
    name: 'l.gabed.fournisseur_materiel',
  },
  {
    path: '/ajoutFournisseur/:sousTypeFrom',
    component: editionFournisseur,
    name: 'm.gabed.fournisseur_materiel',
  },
  {
    path: '/detailFournisseurMateriel/:id/:sousTypeFrom',
    component: detailFournisseur,
    name: 'c.gabed.fournisseur_materiel',
  },
  {
    path: '/editionFournisseur/:id/:sousTypeFrom',
    component: editionFournisseur,
    name: 'm.gabed.fournisseur_materiel-edition',
  },
  {
    path: '/ajoutTitreRecette',
    component: editionTitreRecette,
    name: 'm.gabed.titre_recette-ajout',
  },
  {
    path: '/editionTitreRecette/:id',
    component: editionTitreRecette,
    name: 'm.gabed.titre_recette-edition',
  },
  {
    path: '/detailTitreRecette/:id',
    component: detailTitreRecette,
    name: 'c.gabed.titre_recette',
  },
  {
    path: '/editionTitreRecetteSaveToEdit/:id',
    component: editionTitreRecette,
    name: 'm.gabed.titre_recette-save-to-edit',
  },
  {
    path: '/creer-avoir-titre-recette',
    component: editionTitreRecette,
    name: 'm.gabed.titre_recette-save-to-edit-avoir',
  },
  {
    path: '/listeTitreRecette',
    component: listeTitreRecette,
    name: 'l.gabed.titre_recette',
  },
  {
    path: '/listePaiementRecette',
    component: listePaiementRecette,
    name: 'l.gabed.paiement_recette',
  },
  {
    path: '/listeLotPaiementRecette',
    component: listeLotPaiementRecette,
    name: 'l.gabed.lot_paiement_recette',
  },
  {
    path: '/detailLotPaiementRecette/:id',
    component: detailLotPaiementRecette,
    name: 'c.gabed.lot_paiement_recette',
  },
  {
    path: '/editionLotPaiementRecette/:id',
    component: editionLotPaiementRecette,
    name: 'm.gabed.lot_paiement_recette',
  },
  {
    path: '/listeJournalPaiementRecette',
    component: listeJournalPaiementRecette,
    name: 'l.gabed.journal_paiement_recette',
  },
  {
    path: '*',
    redirect: PAGE_DEFAULT,
  },
];
